

// eslint-disable-next-line
import { handleResponseJson,handleResponseVoid, handleError } from "../../apiUtils";
import { ClientCompletedSessionStub } from "../Interfaces/ClientCompletedSessionStub";
import { CompletedSessionStub } from "../Interfaces/CompletedSessionStub";
import { SessionStub } from "../Interfaces/SessionStub";
import { ActiveSessionStub } from "../Interfaces/ActiveSessionStub";

    /**
    * Gets the active sessions for display in the queue.
    **/
    export function activeSessions( authToken:string): Promise<ClientCompletedSessionStub[]>{
        var url = `api/mentor/queues/ActiveSessions`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Gets sessions assigned to the mentor to display in the queue.
    **/
    export function assignedQueue( authToken:string): Promise<CompletedSessionStub[]>{
        var url = `api/mentor/queues/AssignedQueue`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Gets partially completed sessions assigned to the mentor to display in the queue.
    **/
    export function partiallyComplete( authToken:string): Promise<ClientCompletedSessionStub[]>{
        var url = `api/mentor/queues/PartiallyComplete`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Gets sessions currently with a mentee in waiting to display in the queue.
    **/
    export function queuedSessions( authToken:string): Promise<SessionStub[]>{
        var url = `api/mentor/queues/QueuedSessions`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Gets recently completed sessions the mentor is assigned to to display in the queue.
    **/
    export function recentlyCompleted( authToken:string): Promise<CompletedSessionStub[]>{
        var url = `api/mentor/queues/RecentlyCompleted`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Gets upcoming sessions the mentor is assigned to to display in the queue.
    **/
    export function upcomingSessions( authToken:string): Promise<ActiveSessionStub[]>{
        var url = `api/mentor/queues/UpcomingSessions`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }



